export default __webpack_public_path__ + "static/media/T13E.43d27ca5.png";